<ng-container *ngIf="viewModel$ | async as viewModel">
  <ng-container *ngIf="viewModel.minimalView; else fullView">
    <section class="p-mt-5">
      <header class="p-mb-3">
        <h2>Where are you moving from?</h2>
        <p-button
          icon="pi pi-times"
          ariaLabel="Skip start address"
          [text]="true"
          (onClick)="store.dispatch(actions.exitMinimalViewButtonClicked())"
        ></p-button>
      </header>
      <div class="form-field" *ngIf="googleHelper.loaded | async">
        <label for="minimalStartAddress">Address</label>
        <div class="p-inputgroup">
          <input
            id="minimalStartAddress"
            [ngModel]="viewModel.address"
            #minimalAutocompleteModel="ngModel"
            ngx-gp-autocomplete
            pInputText
            autocomplete="off"
            (onAddressChange)="
              store.dispatch(
                actions.googleAutocompleteAddressSelected({
                  address: $event,
                  locationType: 'start',
                  openWizard: true,
                })
              )
            "
            (input)="
              store.dispatch(
                actions.googleAutocompleteInputChanged({
                  address: $any($event.target).value,
                  locationType: 'start',
                })
              )
            "
            [inputStyle]="{ width: '100%' }"
            [ngClass]="{
              'location-invalid':
                viewModel.locationInvalid && minimalAutocompleteModel.dirty,
            }"
          />
          <button
            type="button"
            pButton
            pRipple
            icon="pi pi-map-marker"
            class="p-button-secondary p-button-outlined"
            pTooltip="Add a location without using the autocomplete"
            (click)="
              store.dispatch(
                actions.addLocationManuallyButtonClicked({
                  locationType: 'start',
                })
              )
            "
          ></button>
        </div>
        <small
          *ngIf="viewModel.locationInvalid && minimalAutocompleteModel.dirty"
          class="field-error-message"
        >
          You must use autocomplete to set the location.
        </small>
      </div>
    </section>
  </ng-container>
  <ng-template #fullView>
    <app-overview-locations></app-overview-locations>
  </ng-template>
</ng-container>
